"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServerSideAuthAllowedCookie = exports.createTokenCookiesRemoveOptions = exports.createTokenCookiesSetOptions = exports.createTokenRemoveCookies = exports.createTokenCookies = void 0;
const adapter_core_1 = require("aws-amplify/adapter-core");
const constant_1 = require("../constant");
const getAccessTokenUsername_1 = require("./getAccessTokenUsername");
const origin_1 = require("./origin");
const createTokenCookies = ({ tokensPayload, userPoolClientId, }) => {
    const { access_token, id_token, refresh_token } = tokensPayload;
    const username = (0, getAccessTokenUsername_1.getAccessTokenUsername)(access_token);
    const authCookiesKeys = (0, adapter_core_1.createKeysForAuthStorage)(adapter_core_1.AUTH_KEY_PREFIX, `${userPoolClientId}.${username}`);
    return [
        {
            name: authCookiesKeys.accessToken,
            value: access_token,
        },
        {
            name: authCookiesKeys.idToken,
            value: id_token,
        },
        {
            name: authCookiesKeys.refreshToken,
            value: refresh_token,
        },
        {
            name: `${adapter_core_1.AUTH_KEY_PREFIX}.${userPoolClientId}.LastAuthUser`,
            value: username,
        },
    ];
};
exports.createTokenCookies = createTokenCookies;
const createTokenRemoveCookies = (keys) => keys.map(key => ({ name: key, value: '' }));
exports.createTokenRemoveCookies = createTokenRemoveCookies;
const createTokenCookiesSetOptions = ({ domain, sameSite, expires, maxAge }, origin) => {
    const result = {
        domain,
        path: '/',
        httpOnly: true,
        secure: (0, origin_1.isSSLOrigin)(origin),
        sameSite: sameSite ?? 'strict',
        expires,
        maxAge,
    };
    // when expires and maxAge both are not specified, we set a default maxAge
    if (!result.expires && !result.maxAge) {
        result.maxAge = adapter_core_1.DEFAULT_AUTH_TOKEN_COOKIES_MAX_AGE;
    }
    return result;
};
exports.createTokenCookiesSetOptions = createTokenCookiesSetOptions;
const createTokenCookiesRemoveOptions = (setCookieOptions) => ({
    domain: setCookieOptions?.domain,
    path: '/',
    maxAge: constant_1.REMOVE_COOKIE_MAX_AGE, // Expire immediately (remove the cookie)
});
exports.createTokenCookiesRemoveOptions = createTokenCookiesRemoveOptions;
const isServerSideAuthAllowedCookie = (cookieName) => constant_1.SERVER_AUTH_ALLOWED_AMPLIFY_AUTH_KEY_SUFFIX.some(suffix => cookieName.endsWith(suffix));
exports.isServerSideAuthAllowedCookie = isServerSideAuthAllowedCookie;
